// extracted by mini-css-extract-plugin
module.exports = {"container":"_2QEaCJ","cancellationContainer":"_2hMIZj","header":"_26p2hr","title":"yVopMu","message":"QgCyKd","limit":"patge1","email":"WsZgAX mz-caption","button":"_3Tq83r"};